import { render, staticRenderFns } from "./orderProcess.vue?vue&type=template&id=d0f36012&scoped=true&"
import script from "./orderProcess.vue?vue&type=script&lang=js&"
export * from "./orderProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f36012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0f36012')) {
      api.createRecord('d0f36012', component.options)
    } else {
      api.reload('d0f36012', component.options)
    }
    module.hot.accept("./orderProcess.vue?vue&type=template&id=d0f36012&scoped=true&", function () {
      api.rerender('d0f36012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/orderProcess.vue"
export default component.exports